
/* injects from baggage-loader */
require('./style.scss');

import React from "react";
import { connect } from "react-redux";
import Config from "../../../config/main";
import { ClosePopup } from "../../../actions/ui";

const Rules = ({ dispatch }) => (
    <div className="ver-center-view-b rules-popup-main">
        <div className="popup-content-view-m timer-visible false">
            <div className="rules-popup">
                <iframe src={Config.rulesURL} />
                <button className="button-view-normal-m rules-button" onClick={() => dispatch(ClosePopup())}>OK</button>
            </div>
        </div>
    </div>
);

export default connect()(Rules);